import { Locales } from '@carsys/enums/locales'
import {
  GetGMSStatsCsvRequestParams,
  GetWholesalerOrderInfoCsvRequestParams,
  ShopModulesRequestParams,
  StatisticsSubsetRequestParams,
  StatsticsRequestParams
} from '.'

export const getStatisticsDashboard = (params: StatsticsRequestParams) => ({
  url: '/modules/statistics/dashboard',
  method: 'GET',
  params: convertStatParamsToQueryParams(params)
})

export const getStatisticsAppointments = (params: StatsticsRequestParams) => {
  return {
    url: '/modules/statistics/appointments',
    method: 'GET',
    params: convertStatParamsToQueryParams(params)
  }
}

export const getStatisticsSubset = (params: StatisticsSubsetRequestParams) => {
  return {
    url: '/modules/statistics/subset',
    method: 'GET',
    params: convertStatParamsToQueryParams(params)
  }
}

export const getStatisticsShopsPerState = (params: StatsticsRequestParams) => {
  return {
    url: '/modules/statistics/shops-per-state',
    method: 'GET',
    params: convertStatParamsToQueryParams(params)
  }
}

export const getWholesalerOrderInfoCsv = (params: GetWholesalerOrderInfoCsvRequestParams) => {
  return {
    url: '/modules/statistics/shop-wholesaler-order-info',
    method: 'GET',
    params: convertStatParamsToQueryParams(params)
  }
}

export const getGMSStatsCsv = (params: GetGMSStatsCsvRequestParams) => {
  return {
    url: '/modules/statistics/gms',
    method: 'GET',
    params: convertStatParamsToQueryParams(params)
  }
}

export const getShopCountries = (locale?: Locales) => {
  return {
    url: '/miscellaneous/countries-all-shops',
    method: 'GET',
    params: {
      Locale: locale
    }
  }
}

const convertStatParamsToQueryParams = (input: ShopModulesRequestParams): any => {
  const output: any = input
  if (input.ShopModules) {
    output.ShopModules = Object.keys(input.ShopModules).reduce(
      (accum, curr) => `${accum ? `${accum},` : ''}${curr}=${input.ShopModules![curr]}`,
      ''
    )
  }
  return output
}
